








import { defineComponent } from '@vue/composition-api';

import PanelWithWithdrawCreate from '@/components/Withdraw/PanelWithWithdrawCreate.vue';

const CreateProduction = defineComponent({
  components: { PanelWithWithdrawCreate },
  // setup() {},
});

export default CreateProduction;
